import { default as MuiAccordion, AccordionProps } from '@mui/material/Accordion'
import { makeStyles } from '@mui/styles'
import classNames from 'classnames'
import * as React from 'react'

const useStyles = makeStyles({
  root: {
    width: '100%',
    minHeight: 'auto',
    background: 'none',
    boxShadow: 'none',
    '&:before': {
      content: 'none',
    },
  },
})

// The default element type of MUI's Accordion is 'div' and the change of this prop is not allowed
type AccordionRef = HTMLElementTagNameMap['div']

// eslint-disable-next-line no-shadow
export const Accordion = React.forwardRef<AccordionRef, AccordionProps>(function Accordion(
  { className, ...props },
  ref,
) {
  const classes = useStyles()
  return <MuiAccordion {...props} className={classNames(className, classes.root)} ref={ref} />
})

export default Accordion
